import React from 'react';
import PropTypes from 'prop-types';
import "./NotificationList.css";
import BaseList from '../../../components/BaseList';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import { convertDateFormat } from 'utils/function';

const propTypes = {
  items: PropTypes.array,
  onClick: PropTypes.func,
  onDelete: PropTypes.func
};
const defaultProps = {
  items: [],
  onClick: (item) => { },
  onDelete: (item) => { }
};
const NotificationList = (props) => {
  /*** States and Variables ***/
  /*** Processing ***/
  /*** Sub Components ***/
  const renderHeader = () => {
    return <>
      <div className='notification_list_header_item'>
        <div className='notification_list_valid_date_header_cell'>
          表示期間
        </div>
        <div className='notification_list_content_header_cell'>
          お知らせ
        </div>
        <div className='notification_list_date_header_cell'>
          更新日
        </div>
        <div className='notification_list_action_cell'>
        </div>
      </div>
      <div className='notification_list_separator' />
    </>;
  }
  const renderItem = (item) => {
    return <>
      <div
        key={"item" + item.id}
        className={`notification_list_item`}>
        <div className='notification_list_valid_date_cell' onClick={() => props.onClick(item)}>
          {convertDateFormat(item.startDate)} ~ {convertDateFormat(item.endDate)}
        </div>
        <div className='notification_list_content_cell' onClick={() => props.onClick(item)}>
          {item.content}
        </div>
        <div className='notification_list_date_cell'>
          {convertDateFormat(item.updatedAt)}
        </div>
        <div className='notification_list_action_cell'>
          <button className='notification_list_button_delete' onClick={() => { props.onDelete(item) }}>
            <FontAwesomeIcon icon={faTrash} />
          </button>
        </div>
      </div>
      <div
        key={"separator" + item.id}
        className='notification_list_separator' />
    </>;
  }
  /*** Event Handlers ***/
  /*** Main Render ***/
  return <BaseList
    items={props.items}
    renderHeader={renderHeader}
    renderItem={renderItem} />;
}
NotificationList.propTypes = propTypes;
NotificationList.defaultProps = defaultProps;
export default NotificationList;